import { componentSelector } from 'wordpress/selectors'
import Search from './Search'
import Gallery from './Gallery'

import { setParkingMode } from 'booking/actions'
import { parkingModeSelector } from 'booking/selectors'
import '../styles/FindAndBook.scss'

const FindAndBook = ({ search: { gallery, title }, setParkingMode, parkingMode }) => (
    <div className="find-and-book d-flex">
        <Gallery gallery={gallery} />
        <div className="content">
            {title && <h1 className="text-white">{title}</h1>}
            <div className="search-selection-container">
                <Search setParkingMode={setParkingMode} parkingMode={parkingMode} />
            </div>
        </div>
    </div>
)

const mapStateToProps = createStructuredSelector({
    search: componentSelector('search'),
    parkingMode: parkingModeSelector,
})

export default connect(mapStateToProps, { setParkingMode })(FindAndBook)
